import script from "./ManualModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManualModal.vue?vue&type=script&setup=true&lang=ts"

import "./ManualModal.vue?vue&type=style&index=0&id=201944a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-201944a7"]])

export default __exports__